import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { dataSesion, SesionService } from '@service/sesion.service';

@Directive({
  selector: '[rolesHide]'
})
export class RolesHideDirective {

  @Input() set rolesHide(roles: Array<string>) {
    if (roles.indexOf(dataSesion.perfil) > -1 || roles.indexOf(dataSesion.codigoperfil) > -1) {
      this._viewContainerRef.clear();
    } else {
      this._viewContainerRef.createEmbeddedView(this._templateRef);
    }
  }
  constructor(private _templateRef: TemplateRef<any>, private _viewContainerRef: ViewContainerRef, private _dataSesion: SesionService) { }

}
